import { LvgTickerChart } from 'components/Organisms/PriceGraph/ReactStocksCharts/LvgTickerChart'
import { useLayoutEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import useResizeObserver from '@react-hook/resize-observer'
import { useIntervalWhen } from 'utils/hooks/useIntervalWhen'
import { icons } from 'common'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { LvgCandleChart } from 'components/Organisms/PriceGraph/ReactStocksCharts/LvgCandleChart'
import { LVG_GRAPH_OPTIONS } from 'constants/games/lvg/lvgGraphsOptions'
import { ChartSelector } from 'components/Molecules/ChartSelector'

export const PriceGraph = ({ assetInfo, graphId, onGraphId }) => {
  const [selectedOption, setSelectedOption] = useState(LVG_GRAPH_OPTIONS.at(1))

  const target = useRef(null)
  const size = useSize(target)
  const [graphWidth, setGraphWidth] = useState()
  const [isToggling, setToggling] = useState(false)

  useIntervalWhen(
    () => {
      setToggling(false)
    },
    100,
    isToggling,
    false
  )

  useLayoutEffect(() => {
    const newWidth = Number((size?.width - 5).toFixed())
    setToggling(true)
    setGraphWidth(newWidth)
  }, [size?.width])

  const filteredOptions = useMemo(
    () =>
      LVG_GRAPH_OPTIONS
        //filter by asset type
        .filter((option) => !option.hideIf.includes(assetInfo?.type))
        //filter by asset id
        .filter((option) => !option.hideIf.includes(assetInfo?.id)),
    [assetInfo?.id]
  )

  const onSelectOption = (option) => {
    onGraphId && onGraphId(option.id)
    setSelectedOption(option)
  }

  return (
    <GraphContainer ref={target}>
      <ChartSelector
        options={filteredOptions}
        selectedOption={selectedOption}
        onSelect={onSelectOption}
      />
      <ContentSwitcherByState
        noWrapper
        activeState={selectedOption?.chart}
        stateObject={{
          tick: !!size && (
            <LvgTickerChart
              width={graphWidth}
              height={size?.height}
              isToggling={isToggling}
            />
          ),
          candle: !!size && (
            <LvgCandleChart
              width={graphWidth}
              height={size?.height}
              isToggling={isToggling}
              assetId={assetInfo?.id}
              interval={selectedOption?.interval}
            />
          ),
          default: null,
        }}
      />
    </GraphContainer>
  )
}

const GraphContainer = styled.div`
  position: relative;
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: var(--lvg-graph-container-margin-top) 0 0 0;
  svg.react-stockchart {
    left: 5px;
  }
  .react-stockcharts-axis-domain,
  g.tick {
    stroke: rgb(100, 102, 106);
  }
  .react-stockcharts-crosshair-cursor {
    cursor: url(${icons.crosshair_yellow_18}) 9 9, crosshair;
  }
`

const useSize = (target) => {
  const [size, setSize] = useState({})

  useLayoutEffect(() => {
    setSize(target.current.getBoundingClientRect())
  }, [target])

  // Where the magic happens
  useResizeObserver(target, (entry) => setSize(entry.contentRect))
  return size
}
